import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "area_body" }
const _hoisted_3 = { class: "area_section" }
const _hoisted_4 = { class: "area_tab" }
const _hoisted_5 = { class: "area_section" }
const _hoisted_6 = { class: "area_table" }
const _hoisted_7 = { class: "area_table_head" }
const _hoisted_8 = { class: "select-wrap" }
const _hoisted_9 = { style: {"display":"flex","justify-content":"center","align-items":"center"} }
const _hoisted_10 = { class: "total_length" }
const _hoisted_11 = {
  class: "area_button",
  style: {"margin-left":"5px"}
}
const _hoisted_12 = { class: "area_table_body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Left = _resolveComponent("Left")!
  const _component_DataGrid = _resolveComponent("DataGrid")!
  const _component_AccessDetail = _resolveComponent("AccessDetail")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Left),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", null, [
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "area_title" }, [
          _createElementVNode("p", null, "수정/삭제 승인(상담일지) 목록")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass({ selected: $setup.state.dept === null }),
                onClick: _cache[0] || (_cache[0] = ($event: any) => {
                                $setup.state.dept = null;
                                $setup.fnGetList(1);
                            })
              }, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("span", null, "전체", -1)
              ]))], 2),
              _createElementVNode("div", {
                class: _normalizeClass({ selected: $setup.state.dept === 1 }),
                onClick: _cache[1] || (_cache[1] = ($event: any) => {
                                $setup.state.dept = 1;
                                $setup.fnGetList(1);
                            })
              }, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("span", null, "상담팀", -1)
              ]))], 2),
              _createElementVNode("div", {
                class: _normalizeClass({ selected: $setup.state.dept === 3 }),
                onClick: _cache[2] || (_cache[2] = ($event: any) => {
                                $setup.state.dept = 3;
                                $setup.fnGetList(1);
                            })
              }, [...(_cache[11] || (_cache[11] = [
                _createElementVNode("span", null, "현장팀", -1)
              ]))], 2),
              _createElementVNode("div", {
                class: _normalizeClass({ selected: $setup.state.dept === 4 }),
                onClick: _cache[3] || (_cache[3] = ($event: any) => {
                                $setup.state.dept = 4;
                                $setup.fnGetList(1);
                            })
              }, [...(_cache[12] || (_cache[12] = [
                _createElementVNode("span", null, "기타", -1)
              ]))], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("select", {
                    name: "orderType",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.state.order) = $event)),
                    onChange: _cache[5] || (_cache[5] = ($event: any) => ($setup.fnGetList(1)))
                  }, [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("option", { value: "0" }, "최근순", -1),
                    _createElementVNode("option", { value: "1" }, "과거순", -1)
                  ]))], 544), [
                    [_vModelSelect, $setup.state.order]
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("notice.total")) + " : " + _toDisplayString($setup.CommonUtils.numberFormat($setup.pageState.length)) + " " + _toDisplayString(_ctx.$t("notice.count")), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.confirmAccessAll && $setup.confirmAccessAll(...args)))
                    }, [...(_cache[14] || (_cache[14] = [
                      _createElementVNode("span", null, "일괄 승인", -1)
                    ]))])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_DataGrid, {
                  list: $setup.pageState.list,
                  columns: $setup.pageState.fields,
                  totalLength: $setup.pageState.length,
                  perPage: $setup.pageState.perPage,
                  cntPage: $setup.pageState.cntPage,
                  "current-page": $setup.pageState.currentPage,
                  isLoading: $setup.pageState.isLoading,
                  onOnRowClick: $setup.fnRowClick,
                  onOnPaging: $setup.fnGetList,
                  onOnNextPage: $setup.fnGoPage,
                  onOnPrevPage: $setup.fnGoPage,
                  onOnFirstPage: $setup.fnGoPage,
                  onOnLastPage: $setup.fnGoPage,
                  onAllClick: $setup.selectAll
                }, null, 8, ["list", "columns", "totalLength", "perPage", "cntPage", "current-page", "isLoading", "onOnRowClick", "onOnPaging", "onOnNextPage", "onOnPrevPage", "onOnFirstPage", "onOnLastPage", "onAllClick"])
              ])
            ])
          ])
        ])
      ])
    ]),
    ($setup.state.isShowDetail)
      ? (_openBlock(), _createBlock(_component_AccessDetail, {
          key: 0,
          idx: $setup.state.idx,
          onClose: _cache[7] || (_cache[7] = ($event: any) => ($setup.state.isShowDetail = false)),
          onCallback: _cache[8] || (_cache[8] = ($event: any) => {
            $setup.state.isShowDetail = false;
            $setup.fnGetList($setup.pageState.currentPage);
        })
        }, null, 8, ["idx"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 1,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}